<template>
  <div>
    <v-card v-if="!$store.getters.merchantDelegationFormStatus">
      <v-card-title>
        <div class="w-100 d-flex flex-row justify-content-between">
          <div>نمایندگی های من </div>
          <div>
            <v-btn
              class="mx-1 float-left"
              color="primary"
              @click.stop="openCreateOrEditDialog()"
            >
              نمایندگی جدید</v-btn
            >
          </div>
        </div>
      </v-card-title>
      <v-divider> </v-divider>
      <v-card-text>
        <merchant-delegations-list categoryType="Product">
        </merchant-delegations-list>
      </v-card-text>
    </v-card>
    <merchant-delegation-form v-else categoryType="Product">
    </merchant-delegation-form>
  </div>
</template>

<script>
import MerchantDelegationsList from '../components/MerchantDelegationsList.vue';
import MerchantDelegationForm from '../components/MerchantDelegationForm.vue';
export default {
  components: {
    MerchantDelegationsList,
    MerchantDelegationForm,
  },

  methods: {
    openCreateOrEditDialog() {
      this.$store.commit('setMerchantDelegationFormStatus', true);
    },
  },
};
</script>

<style lang="scss" scoped></style>
